
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/jdih",
      function () {
        return require("private-next-pages/service/jdih/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/jdih"])
      });
    }
  